import { useRef } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

/**
 * A button/anchor that pulls slightly toward the cursor on hover.
 * Props:
 *   as — "button" | "a" (default "button")
 *   className, onClick, href — passed through
 */
export function MagneticButton({ children, className, onClick, href, as: Tag = "button" }) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  // stiffness:300 damping:20 — snappy spring per UI Pro Max
  const springX = useSpring(x, { stiffness: 300, damping: 20 });
  const springY = useSpring(y, { stiffness: 300, damping: 20 });

  const handleMouseMove = (e) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    x.set((e.clientX - (rect.left + rect.width / 2)) * 0.3);
    y.set((e.clientY - (rect.top + rect.height / 2)) * 0.3);
  };

  const handleMouseLeave = () => {
    x.set(0);
    y.set(0);
  };

  const MotionTag = Tag === "a" ? motion.a : motion.button;

  return (
    <MotionTag
      ref={ref}
      className={className}
      onClick={onClick}
      href={href}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      style={{ x: springX, y: springY }}
      // scale press feedback per UI Pro Max spec (0.97 on tap)
      whileTap={{ scale: 0.97 }}
    >
      {children}
    </MotionTag>
  );
}
